import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {DatePickerSegment as $8fe48145f400a5cb$export$6388987c5223b54e} from "./DatePickerSegment.mjs";
import "./styles.css";
import $dvZJj$styles_cssmjs from "./styles_css.mjs";
import {Field as $adcd096854d27620$export$a455218a85c89869} from "../label/Field.mjs";
import {Input as $51cb122633c52627$export$f5b8910cec6cf069} from "./Input.mjs";
import {useFocusManagerRef as $d24c665d02225161$export$71a23a36270e4bf0, useFormatHelpText as $d24c665d02225161$export$322f4580ccd8dde6, useFormattedDateWidth as $d24c665d02225161$export$31e22e3c931fc056} from "./utils.mjs";
import {useFormProps as $c29c48d4ef19ffc4$export$a6b5be5c6b451665} from "../form/Form.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useDateField as $dvZJj$useDateField} from "react-aria/useDateField";
import {createCalendar as $dvZJj$createCalendar} from "@internationalized/date";
import $dvZJj$react, {useRef as $dvZJj$useRef} from "react";
import {useDateFieldState as $dvZJj$useDateFieldState} from "react-stately/useDateFieldState";
import {useLocale as $dvZJj$useLocale} from "react-aria/I18nProvider";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 












const $4625bab37510e72e$export$d9781c7894a82487 = /*#__PURE__*/ (0, $dvZJj$react).forwardRef(function DateField(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $c29c48d4ef19ffc4$export$a6b5be5c6b451665)(props);
    let { autoFocus: autoFocus, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, isQuiet: isQuiet } = props;
    let domRef = (0, $d24c665d02225161$export$71a23a36270e4bf0)(ref);
    let { locale: locale } = (0, $dvZJj$useLocale)();
    let state = (0, $dvZJj$useDateFieldState)({
        ...props,
        locale: locale,
        createCalendar: $dvZJj$createCalendar
    });
    let fieldRef = (0, $dvZJj$useRef)(null);
    let inputRef = (0, $dvZJj$useRef)(null);
    let { labelProps: labelProps, fieldProps: fieldProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $dvZJj$useDateField)({
        ...props,
        inputRef: inputRef
    }, state, fieldRef);
    // Note: this description is intentionally not passed to useDatePicker.
    // The format help text is unnecessary for screen reader users because each segment already has a label.
    let description = (0, $d24c665d02225161$export$322f4580ccd8dde6)(props);
    if (description && !props.description) descriptionProps.id = undefined;
    let validationState = state.validationState || (isInvalid ? 'invalid' : null);
    let approximateWidth = (0, $d24c665d02225161$export$31e22e3c931fc056)(state) + 'ch';
    return /*#__PURE__*/ (0, $dvZJj$react).createElement((0, $adcd096854d27620$export$a455218a85c89869), {
        ...props,
        ref: domRef,
        elementType: "span",
        description: description,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        validationState: validationState ?? undefined,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        wrapperClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dvZJj$styles_cssmjs))), 'react-spectrum-Datepicker-fieldWrapper')
    }, /*#__PURE__*/ (0, $dvZJj$react).createElement((0, $51cb122633c52627$export$f5b8910cec6cf069), {
        ref: fieldRef,
        fieldProps: fieldProps,
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        autoFocus: autoFocus,
        validationState: validationState,
        minWidth: approximateWidth,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dvZJj$styles_cssmjs))), 'react-spectrum-DateField')
    }, state.segments.map((segment, i)=>/*#__PURE__*/ (0, $dvZJj$react).createElement((0, $8fe48145f400a5cb$export$6388987c5223b54e), {
            key: i,
            segment: segment,
            state: state,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isRequired: isRequired
        })), /*#__PURE__*/ (0, $dvZJj$react).createElement("input", {
        ...inputProps,
        ref: inputRef
    })));
});


export {$4625bab37510e72e$export$d9781c7894a82487 as DateField};
//# sourceMappingURL=DateField.mjs.map
